import React, { memo } from "react";
import { SidebarPanel } from "../sidebar-panel";
import "./sidebar-options-panel.css";
import "shared/styles/product-options.css";
import { useAlternativeProducts } from "../../../hooks/useAlternativeProducts";
import { SidebarAlternativeProducts } from "./sidebar-alternative-products";
import { SidebarStartDate } from "./sidebar-start-date";
import { useSupportedProductStartDate } from "../../../hooks/useSupportedProductStartDate";
import { SidebarProductOptions } from "./sidebar-product-options";
import { useProductOptions } from "../../../hooks/useProductOptions";

export const SidebarOptionsPanel = memo(function SidebarOptionsPanel() {
	const supportedStartDate = useSupportedProductStartDate();
	const { alternativeProductsGroups } = useAlternativeProducts();
	const { productOptionGroup } = useProductOptions();

	return (
		<SidebarPanel.Root>
			<SidebarPanel.Content scrollable fade>
				{supportedStartDate && <SidebarStartDate supportedStartDate={supportedStartDate} />}

				{alternativeProductsGroups?.map((group) => (
					<SidebarAlternativeProducts key={group.name} group={group} />
				))}

				{productOptionGroup && <SidebarProductOptions group={productOptionGroup} />}
			</SidebarPanel.Content>
		</SidebarPanel.Root>
	);
});
